import { GA4Item } from '../types/global'

export type ItemsLike = { items?: Pick<GA4Item, 'item_id'>[] } | undefined

function extractItems(data: ItemsLike | { ecommerce_ga4?: ItemsLike }) {
  const items =
    (data as { items?: Pick<GA4Item, 'item_id'>[] })?.items ||
    (data as { ecommerce_ga4?: ItemsLike })?.ecommerce_ga4?.items ||
    []

  if (!Array.isArray(items) || items.length === 0) {
    return []
  }

  return items
}

export function computeItemIdFields(
  data: ItemsLike | { ecommerce_ga4?: ItemsLike },
): { item_id?: string; item_ids?: string } {
  const ids = extractItems(data)
    .map((item) => item?.item_id)
    .filter(Boolean) as string[]

  if (ids.length === 0) {
    return {}
  }

  return {
    item_id: ids[0], // primary id for GTM/Ads triggers expecting a single value
    item_ids: ids.length > 1 ? ids.join(',') : undefined, // optional full list if needed
  }
}
